<template>
	<client-only>
		<div class="deposit-guide ibm-font">
		<component :is="View" v-bind="wrapperProps">
			<template #title>
				<div class="header">
					<div @click="handleCancel"><r-icon class="deposit-guide-close" name="icon-actions_navigation_close" /></div>
					<div v-show="mobileSize" class="deposit-guide-title__mobileSize">
						{{ $t('deposit-guide.deposit-method') }}
					</div>
				</div>
			</template>
			<div v-show="!mobileSize" class="deposit-guide-title">{{ $t('deposit-guide.deposit-method') }}</div>
			<div class="deposit-guide-way">
				<div class="deposit-guide-way__item__wrapper" @click="handleCancel">
					<nuxt-link :to="`/asset-deposit/${locale}`" class="deposit-guide-way__item">
						<IconDepositCrypto alt="SVG Icon" class="deposit-guide-item__icon" />
						<div class="deposit-guide-item__info">
							<div class="deposit-guide-item__info__title">{{ $t('deposit-guide.deposit-method-1-title') }}</div>
							<div class="deposit-guide-item__info__desc">{{ $t('deposit-guide.deposit-method-1-desc') }}</div>
						</div>
						<r-icon name="icon-back" class="deposit-guide-item__go" />
					</nuxt-link>
				</div>
				<div v-if="!isApp" @click="handleCancel" class="deposit-guide-way__item__wrapper">
					<nuxt-link :to="`/buy-sell/${locale}`" class="deposit-guide-way__item">
						<IconDepositCard alt="SVG Icon" class="deposit-guide-item__icon" />
						<div class="deposit-guide-item__info">
							<div class="deposit-guide-item__info__title">{{ $t('deposit-guide.deposit-method-2-title') }}</div>
							<div class="deposit-guide-item__info__desc">{{ $t('deposit-guide.deposit-method-2-desc') }}</div>
						</div>
						<r-icon name="icon-back" class="deposit-guide-item__go" />
					</nuxt-link>
				</div>
				<div v-else class="deposit-guide-way__item__wrapper" @click="toDepositInApp">
					<div class="deposit-guide-way__item">
						<IconDepositCard alt="SVG Icon" class="deposit-guide-item__icon" />
						<div class="deposit-guide-item__info">
							<div class="deposit-guide-item__info__title">{{ $t('deposit-guide.deposit-method-2-title') }}</div>
							<div class="deposit-guide-item__info__desc">{{ $t('deposit-guide.deposit-method-2-desc') }}</div>
						</div>
						<r-icon name="icon-back" class="deposit-guide-item__go" />
					</div>
				</div>
			</div>
		</component>
	</div>
	</client-only>
</template>

<script>
import messages from './i18n';
import { usePatchStore } from '~/common/js/patch';
import commonMixin from '@/mixins/common';
import IconDepositCrypto from './img/deposit-crypto.svg';
import IconDepositCard from './img/deposit-card.svg';

import { ElDialog, ElDrawer } from 'element-plus';
export default {
  i18n: { messages },
  name: 'VerifyKyc',
  mixins: [commonMixin],
  components: {
    IconDepositCard,
    IconDepositCrypto,
		ElDialog,
		ElDrawer
  },
  props: {
    kycLevel: {
      // kyc 认证的信息
      type: Number,
      default: 0,
    },
    // requirKyc2: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  data() {
    return {
      current: 0,
      global: null,
      isApp: false,
    }
  },
  computed: {
    locale() {
			return this.store?.locale;
		},
		showDepositGuid() {
			return this.store?.showDepositGuid;
		},
    View() {
      if (!this.global) return ''
      if (this.global.screen.width > 768) {
        return 'ElDialog'
      } else {
        return 'ElDrawer'
      }
    },
    mobileSize() {
      if (!this.global) return false
      return this.global.screen.width <= 768
    },
    wrapperProps() {
      if (this.View == 'ElDrawer') {
        return {
          'model-value': this.showDepositGuid,
          beforeClose: this.beforeClose,
          direction: 'btt',
          class: 'deposit-guide-drawer',
          showClose: false,
          size: 'auto',
        }
      } else {
        return {
          class: 'deposit-guide-dialog',
          'model-value': this.showDepositGuid,
          beforeClose: this.beforeClose,
          showClose: false,
          'close-on-click-modal': false,
        }
      }
    },
  },
  watch: {},
  methods: {
    toDepositInApp() {},
    handleCancel() {
      this.store.commit('HIDE_DEPOSIT_GUID')
    },
    beforeClose() {
      this.store.commit('HIDE_DEPOSIT_GUID')
    },
    onPopstate() {
      this.store.commit('HIDE_DEPOSIT_GUID')
    }
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.onPopstate, false)
  },
  mounted() {
    this.global = window
    this.$$isApp()?.then((isApp) => {
      if (isApp) {
        this.isApp = isApp
      }
    })

    window.addEventListener('popstate', this.onPopstate, false)
  },
  setup() {
		const { store, commit } = usePatchStore();
		return {
			store,
			commit,
		};
	},
}
</script>
<style lang="less">
.day-mode {
	--global-deposit-guide-color-bg: #ffffff;
	--global-deposit-guide-color-bg-400: #fbfbfd;
	--global-deposit-guide-color-text: #141f21;
	--global-deposit-guide-color-text-300: #6a7c81;
}

.night-mode {
	--global-deposit-guide-color-bg: #2a2d37;
	--global-deposit-guide-color-bg-400: #383d4d;
	--global-deposit-guide-color-text: #ffffff;
	--global-deposit-guide-color-text-300: #a4a8b6;
}

.deposit-guide {
	width: auto;
	.el-drawer.deposit-guide-drawer {
		background-color: var(--global-deposit-guide-color-bg, #fff);
		overflow: hidden;
		border-radius: 16px 16px 0px 0px;
		.el-drawer__header {
			overflow: hidden;
			padding: 0;
		}
	}
	.el-dialog {
		width: 90%;
		max-width: 720px;
		border-radius: 8px;
	}

	.el-form-item.is-error .VF__input {
		border: 1px solid #ff4d4f;
	}

	.el-form-item__error {
		padding-top: 0px;
		top: 96%;
	}

	.el-dialog.deposit-guide-dialog .el-dialog__header {
		padding: 0;
		top: 95%;
	}

	.el-dialog.deposit-guide-dialog {
		background-color: var(--global-deposit-guide-color-bg, #fff);
	}

	.el-dialog__body,
	.el-dialog--center .el-dialog__body {
		padding: 0 40px 40px;
	}
}
</style>
<style lang="less" scoped>
@media (min-width: 768px) {
	.deposit-guide-way {
		padding: 50px 0;

		.deposit-guide-way__item__wrapper {
			margin-top: 32px;
			.deposit-guide-way__item {
				width: 640px;
				height: 100px;
				background: var(--global-deposit-guide-color-bg-400, #fbfbfd);
				border-radius: 8px;
				padding: 24px 36px;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				border: 2px solid var(--global-deposit-guide-color-bg-400, #fbfbfd);
				cursor: pointer;
				transition: all 0.3s ease 0s;

				&:hover {
					border: 2px solid #13c2c2;
					box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);

					.deposit-guide-item__go {
						color: #13c2c2;
					}
				}

				.deposit-guide-item__info {
					margin-left: 24px;

					.deposit-guide-item__info__title {
						font-weight: 500;
						font-size: 20px;
						line-height: 28px;
						color: var(--global-deposit-guide-color-text, #141f21);
					}

					.deposit-guide-item__info__desc {
						font-weight: 400;
						font-size: 14px;
						line-height: 20px;
						color: var(--global-deposit-guide-color-text-300, #6a7c81);
					}
				}

				.deposit-guide-item__go {
					margin-left: auto;
					transform-origin: center;
					transform: rotate(180deg);
					transition: all 0.3s ease 0s;
					color: var(--global-deposit-guide-color-text, #141f21);
				}

        .deposit-guide-item__icon {
          path {
            fill: var(--global-deposit-guide-color-text, #141f21);
          }
        }
      }
      &:first-child {
        margin-top: 0;
      }
    }
  }
  .el-dialog__header {
    padding: 0;
  }
  .header {
    padding: 20px 20px 13px;
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
  }
  .deposit-guide-close {
    cursor: pointer;
    color: var(--global-deposit-guide-color-text, #141f21);
  }
  .deposit-guide-title {
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
    color: var(--global-deposit-guide-color-text, #141f21);
  }
}
@media (max-width: 767px) {
  .deposit-guide-close {
    color: var(--global-deposit-guide-color-text, #141f21);
  }
  .deposit-guide-title {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 40px;
    color: var(--global-deposit-guide-color-text, #141f21);
  }
  .deposit-guide-title__mobileSize {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
  }
  .deposit-guide-way {
    padding: 0 20px;
    padding-bottom: 32px;

		.deposit-guide-way__item__wrapper {
			margin-top: 20px;
			.deposit-guide-way__item {
				// width: 640px;
				// height: 100px;
				background: var(--global-deposit-guide-color-bg-400, #fbfbfd);
				border-radius: 8px;
				padding: 18px 20px;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				border: 2px solid var(--global-deposit-guide-color-bg-400, #fbfbfd);
				cursor: pointer;
				transition: all 0.3s ease 0s;

				&:hover {
					border: 2px solid #13c2c2;
					box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);

					.deposit-guide-item__go {
						color: #13c2c2;
					}
				}

				.deposit-guide-item__icon {
					// width: 28px;
					// height: 28px;
					width: 50px;
					height: 44px;
					path {
						fill: var(--global-deposit-guide-color-text, #141f21);
					}
				}

				.deposit-guide-item__info {
					margin-left: 24px;

					.deposit-guide-item__info__title {
						font-weight: 500;
						font-size: 16px;
						line-height: 24px;
						color: var(--global-deposit-guide-color-text, #141f21);
					}

					.deposit-guide-item__info__desc {
						font-weight: 400;
						font-size: 14px;
						line-height: 20px;
						color: var(--global-deposit-guide-color-text-300, #6a7c81);
					}
				}

				.deposit-guide-item__go {
					margin-left: auto;
					transform-origin: center;
					transform: rotate(180deg);
					transition: all 0.3s ease 0s;
					color: var(--global-deposit-guide-color-text, #141f21);
				}
			}
			&:first-child {
				margin-top: 0;
			}
		}
	}
	.header {
		padding: 1em 1em 0.4em;
		display: flex;
		justify-content: space-between;
		flex-direction: row-reverse;
	}
}
</style>
